<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{ ['create','transfer'].includes(action) ? $t('create_delivery') : $t('edit_delivery') }}</h5>
                <small v-if="isDraftAutosaveEnabled && draftAutosaveState !== 'idle'" class="ms-auto me-3 text-muted d-flex align-items-center">
                    <span v-if="draftAutosaveState === 'saving'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <AppIcon name="bi-cloud-check" v-else-if="draftAutosaveState === 'saved'" class="bi bi-cloud-check me-1 text-success" />
                    <AppIcon name="bi-cloud-slash" v-else-if="draftAutosaveState === 'error'" class="bi bi-cloud-slash me-1 text-danger" />
                    <AppIcon name="bi-cloud-arrow-up" v-else class="bi bi-cloud-arrow-up me-1" />
                    {{ draftAutosaveStatusLabel }}
                </small>
                <button type="button" class="btn-close" id="close-modal-btn" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div class="modal-body" style="text-align:left">

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="mb-3">
                                    <label class="form-label">{{$t(from === 'invoices' ? 'invoice' : 'order')}}</label>
                                    <input
                                        v-if="from === 'invoices'"
                                        :value="data?.reference || ''"
                                        type="text"
                                        class="form-control"
                                        readonly
                                    >
                                     <auto-complete
                                        v-else
                                        entity="orders"
                                        emitEvent="emitAutoCompleteOrder"
                                        :defaultValue="data?.reference" 
                                        @emitAutoCompleteOrder="emitAutoCompleteOrder">
                                    </auto-complete>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                            <div class="col-3 col-sm-2" v-if="business?.metadata?.show_client_po_number">
                                <div class="mb-3">
                                    <label for="clientPoNumber" class="form-label">{{$t('client_po_number')}}</label>
                                    <input v-model="localData.client_po_number" type="text" class="form-control" id="clientPoNumber" :placeholder="$t('client_po_number')">
                                </div>
                            </div>
                            <div class="col-3 col-sm-2" v-if="business?.metadata?.show_client_in_number">
                                <div class="mb-3">
                                    <label for="clientInNumber" class="form-label">{{$t('client_in_number')}}</label>
                                    <input v-model="localData.client_in_number" type="text" class="form-control" id="clientInNumber" :placeholder="$t('client_in_number')">
                                </div>
                            </div>
                            <div class="col-3 col-sm-2" v-if="business?.metadata?.show_client_dn_number">
                                <div class="mb-3">
                                    <label for="clientDnNumber" class="form-label">{{$t('client_dn_number')}}</label>
                                    <input v-model="localData.client_dn_number" type="text" class="form-control" id="clientDnNumber" :placeholder="$t('client_dn_number')">
                                </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-xl-5">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="paymentToggle"
                                                v-model="localData.products[i].custom_product"
                                            >
                                        </div>
                                        <label for="paymentToggle" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>

                                <auto-complete  
                                        :uid="i"
                                        v-if="!localData.products[i].custom_product && createClientState === false" 
                                        @emitAutoComplete="emitAutoComplete" 
                                        :defaultValue="localData.products[i].product_label" 
                                        entity="inventories"
                                        emitEvent="emitAutoComplete"
                                        :dislaySuggestions="action =='create' ? true : false " 
                                    ></auto-complete>
                                    <product-rich-text-editor
                                        v-if="localData.products[i].custom_product"
                                        v-model="localData.products[i].product_label"
                                        :placeholder="$t('product_label')"
                                    ></product-rich-text-editor>
                                    <div v-if="localData.products[i].custom_product && canCreateCatalogProducts" class="form-check mt-2">
                                        <input
                                            v-model="localData.products[i].create_catalog_product"
                                            class="form-check-input"
                                            type="checkbox"
                                            :id="'deliveryCreateCatalogProduct' + i"
                                        >
                                        <label class="form-check-label" :for="'deliveryCreateCatalogProduct' + i">
                                            {{ $t('also_add_to_products') }}
                                        </label>
                                    </div>
                                    <div v-if="localData.products[i].product_id && (localData.products[i].maxQty <= 0)" class="text-danger small mt-1">
                                        <AppIcon name="bi-exclamation-triangle-fill" class="bi bi-exclamation-triangle-fill me-1" /> {{ $t('product_out_of_stock_warning') }}
                                    </div>
   
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                            </div>    

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-sm-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('client')}}</label>
                                <!-- client -->
                                <auto-complete  
                                    @emitAutoCompleteClient="emitAutoCompleteClient" 
                                    :defaultValue="localData?.client?.name"
                                    entity="clients"
                                    emitEvent="emitAutoCompleteClient"
                                    v-if="!modalIsLoading"
                                ></auto-complete>
                                <!-- client -->
                                <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateClientModal">
                                    <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_client')}}
                                </a>
                            </div>

                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">
                                    {{$t('status')}}
                                </label>
                                <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                    <option selected value="pending">{{$t('pending')}}</option>
                                    <option value="delivered">{{$t('delivered')}}</option>
                                    <option value="canceled">{{$t('canceled')}}</option>
                                </select>
                            </div>
                        </div>


                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="delivery-notes" rows="3" />
                        </div>
<!-- 
                        <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                    </div>
                                    <div class="alert alert-warning" role="alert" v-if="msgError">
                    {{msgError}}
                </div>
            </template>

            <template #footer>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading">
                    <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                    {{$t('edit')}}
                </button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        <!-- client modal -->
        <add-client 
            v-if="createClientState"  
            :state="createClientState"  
            @createClient="createClient"/>
        <!-- client modal -->


        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-delivery-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="delivery">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddClient from '../AddClient.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import ProductRichTextEditor from '../common/ProductRichTextEditor.vue'
import draftAutosave from '../../mixins/draftAutosave'
import moment from 'moment'
export default {
  name: 'AddEditDeliveryModal',
  mixins: [draftAutosave],
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        },
        from : {
            type : String
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddClient,
    InvoiceTemplateModal,
    ProductRichTextEditor
  },
  data(){
    const parsedData = JSON.parse(JSON.stringify(this.data))

    // A transferred quote/order carries its own document status.
    // Delivery status must start from the delivery workflow instead.
    if (this.action === 'transfer') {
      parsedData.status = 'pending'
    }

    return {
        loading : false,
        invoiceModalisOpen :false,
        createClientState : false,
        localData: parsedData,
        modalIsLoading : false,
        msgError : null
    }
  },

  computed : {
    business(){ return this.$store.getters.BUSINESS},
    isProductModuleEnabled(){ return helper.checkModuleIsEnabled('products') },
    canCreateCatalogProducts(){
        return this.isProductModuleEnabled
            && this.business?.metadata?.allow_custom_product_catalog_creation === true
            && ![-1, -2].includes(helper.checkAccess('create_inventories'))
    },
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
  },
  methods : {
    draftAutosaveResource(){ return 'deliveries' },
    formatDeliveryProducts(products){
        return helper.formatProducts(products, true).map(product => ({
            ...product,
            // Custom delivery lines do not reference an inventory record.
            inventory_id: product.custom_product === true ? null : product.inventory_id
        }))
    },
    async saveRow(){
        try{
            this.loading = true

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_delivery_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }
            
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }

            await helper.createCatalogProductsFromCustomRows(this.localData.products)

            //format products
            this.localData.products = this.formatDeliveryProducts(this.localData.products)

            // Update the existing draft instead of creating a new one
            await this.pauseDraftAutosave()
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/deliveries/${this.localData.id}`,{...this.localData },{showToast:true})
            
            //confirm quote if exists
            if(this?.localData?.quote_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/quotes/${this.localData.quote_id}`,{ status : 'confirmed', delivery_id : this.localData.id },{showToast:false})
            }
            // Confirm multiple quotes if bulk transfer
            if(this?.localData?.quote_ids && Array.isArray(this.localData.quote_ids)){
                 await Promise.all(this.localData.quote_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/quotes/${id}`,{ status : 'confirmed', delivery_id : this.localData.id },{showToast:false})
                 ));
            }
            
            //confirm order if exists
            if(this?.localData?.order_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/orders/${this.localData.order_id}`,{ status : 'confirmed' },{showToast:false})
            }
            // Confirm multiple orders if bulk transfer
            if(this?.localData?.order_ids && Array.isArray(this.localData.order_ids)){
                 await Promise.all(this.localData.order_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/orders/${id}`,{ status : 'confirmed' },{showToast:false})
                 ));
            }
            this.clearForm()
            this.loading = false
            this.modalClosed()
            this.$router.push({path : `/deliveries/${response.data.id}`})
        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_delivery_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }

            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }

            await helper.createCatalogProductsFromCustomRows(this.localData.products)

            //format products
            this.localData.products = this.formatDeliveryProducts(this.localData.products)

            await this.pauseDraftAutosave()
            await helper.customPatch(`${process.env.VUE_APP_API}/deliveries/${this.localData.id}`,{...this.localData })
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            client_po_number: '',
            client_in_number: '',
            client_dn_number: '',
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : false,
            create_catalog_product : false,
            custom_quantity_mode : false
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(['quantity'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices() {
    this.msgError = null;
    this.$forceUpdate();

    for (let i = 0; i < this.localData.products.length; i++) {
        let product = this.localData.products[i];

        const qty = parseFloat(product.quantity) || 0;
        const price = parseFloat(product.price) || 0;
        const vatRate = parseFloat(product.vat) || 0;

        let priceHT = 0;
        let tvaAmount = 0;

        const productPriceIncludesTax = (product.price_includes_tax === true) || (product.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
            // Case 1: Price already includes VAT (TTC)
            priceHT = price / (1 + vatRate / 100);   // Extract HT
            tvaAmount = (price - priceHT) * qty;     // VAT portion
        } else {
            // Case 2: Price is HT
            priceHT = price;
            tvaAmount = vatRate > 0 ? (priceHT * (vatRate / 100)) * qty : 0;
        }

        // Subtotal HT (before VAT)
        product.sub_total = Math.round(priceHT * qty);

        // Save VAT separately (useful for reports/invoices)
        product.tva_amount = Math.round(tvaAmount);

        // Final total TTC
        product.total = Math.round((priceHT * qty) + tvaAmount);
    }

    // Global total TTC
    this.localData.total = this.localData.products?.length
        ? this.localData.products.map(o => o.total).reduce((a, c) => a + c, 0)
        : 0;
},
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.localData.products[index].price = ((price / this.localData.products[index].quantity) / 1.2).toFixed(2)
           this.localData.products[index].sub_total = parseFloat(this.localData.products[index].price) * parseFloat(this.localData.products[index].quantity)
        }
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                // id : data.result.product.id,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                price_includes_tax : (data.result.product?.price_includes_tax === true) || (data.result.price_includes_tax === true),
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                create_catalog_product : false,
                custom_quantity_mode : false
            }}
            this.localData.products = [...this.localData.products]
        }
    },
    emitAutoCompleteClient(data){
        this.localData.client_id = data.result.id
        this.localData.client = data.result
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    createClient(data){
        if(data.client){
            this.localData.client_id = data.client.id
            this.localData.client = data.client
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
            this.modalIsLoading = true
            setTimeout(() => { this.modalIsLoading = false })
        }
    },
    checkIfValidProduct(){
        return this.localData.products.length > 0 && this.localData.products.every(product => (
            product.product_id != null
            || (product.custom_product === true && helper.richTextToPlainText(product.product_label).trim().length > 0)
        ))
    },
    sanitizeCustomProductLabels(){
        this.localData.products.forEach(product => {
            if (product.custom_product) {
                product.product_label = helper.sanitizeRichText(product.product_label)
            }
        })
    },
    async modalClosed(){
        if(this.draftAutosaveClosing) return
        this.draftAutosaveClosing = true
        await this.pauseDraftAutosave(this.draftAutosaveEligible)
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    emitAutoCompleteOrder(data){
        this.modalIsLoading = true
        this.localData.products = data.result.products
        this.localData.order_id = data.result.id
        this.localData.client_id = data.result.client_id
        this.localData.client = data.result.client
        this.calculatePrices()
        setTimeout(() => { this.modalIsLoading = false })
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);}
  },
  async created(){
    let createdServerDraft = false

    //add default status & payment method 
    if(!this.localData.status){
        this.localData.status = 'pending'
    }
    
    if(this.from && this.from == 'orders'){
        this.localData.order = {
            id : this.localData.id,
            reference : this.localData.reference
        }
        this.localData.order_id = this.localData.id
    }

    if(this.localData.date) {
        this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
    }else{
        this.localData.date = moment().format('YYYY-MM-DD')
    }

    if(this.localData.products.length){
        for(let i = 0 ; i < this.localData.products.length ; i++){
                this.$set(this.localData.products[i], 'create_catalog_product', false);
            const q = Number(this.localData.products[i].quantity);
            this.$set(this.localData.products[i], 'custom_quantity_mode', ![0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(q));
        }
    }
 
    // When creating, immediately create a draft on the server and keep its id/reference
    if(['create','transfer'].includes(this.action)){
        const { data } = await helper.customPost(`${process.env.VUE_APP_API}/deliveries/draft`,{})
        createdServerDraft = true
        this.localData.id = data.id
        this.localData.reference = data.reference
        if(data.date){
            this.localData.date = moment(data.date).format('YYYY-MM-DD')
        }
    }
    this.startDraftAutosave(
        createdServerDraft,
        ['create', 'transfer'].includes(this.action) || this.data?.status === 'draft'
    )
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
